import {
  ORGANIZED_TOUR_CURATED_GENERIC_TRAVEL_URL,
  upgradeOrganizedTourRemoteImageUrl,
} from "./organizedTourHeroImageSsot";

/**
 * Curated Unsplash keys → base image path (no query); upgraded on read.
 * Expand `SLUG_TO_PATH` / `IATA_TO_SLUG` for new destinations — no code changes required.
 */
const SLUG_TO_PATH = {
  athens: "photo-1609137144813-7d9921338f24",
  thessaloniki: "photo-1596431680903-8d64f94e24b8",
  greece: "photo-1613395877344-571fabeb2f2b",
  rome: "photo-1552832230-c0197dd771b4",
  paris: "photo-1502602898657-3e91760cbb89",
  london: "photo-1513635269975-59663e0ac1ad",
  dubai: "photo-1512453979798-5ea266f8880c",
  barcelona: "photo-1583422409516-2895a77efded",
  amsterdam: "photo-1534351590666-13e3e96b5017",
  newyork: "photo-1496442226666-8d4d0e62e6e9",
  telaviv: "photo-1542317854-0c41d41d747c",
  montenegro: "photo-1586016413664-864c0dd76f53",
  croatia: "photo-1555992332-7afe4e4e1046",
  budapest: "photo-1541343672888-9e76d93e2fdb",
  prague: "photo-1541849546-216549cd1924",
  vienna: "photo-1516550893923-42d28e5677af",
  istanbul: "photo-1512457970447-af8810cfd9f9",
  lisbon: "photo-1585208798174-6cedd86e019a",
  madrid: "photo-1539037116277-4db20889f2d4",
  berlin: "photo-1560969184-10fe8719e047",
  munich: "photo-1595867818082-083862f3d630",
  zurich: "photo-1516483638261-f4dbaf036963",
  bali: "photo-1537953773345-d172cfb13f37",
  bangkok: "photo-1563492065599-3520f775eeed",
  tokyo: "photo-1540959733332-eab4deabeeaf",
  cyprus: "photo-1580746738099-3005b7f0328f",
  malta: "photo-1570077188670-e07a8936efdf",
};

function urlForSlug(slug) {
  const path = SLUG_TO_PATH[slug];
  if (!path) return "";
  return upgradeOrganizedTourRemoteImageUrl(`https://images.unsplash.com/${path}`);
}

const IATA_TO_SLUG = {
  ATH: "athens",
  LGAV: "athens",
  SKG: "thessaloniki",
  SKG_MAKEDONIA: "thessaloniki",
  FCO: "rome",
  CIA: "rome",
  CDG: "paris",
  ORY: "paris",
  LHR: "london",
  LGW: "london",
  STN: "london",
  DXB: "dubai",
  BCN: "barcelona",
  AMS: "amsterdam",
  JFK: "newyork",
  EWR: "newyork",
  LGA: "newyork",
  TLV: "telaviv",
  TGD: "montenegro",
  TIV: "montenegro",
  DBV: "croatia",
  SPU: "croatia",
  ZAG: "croatia",
  BUD: "budapest",
  PRG: "prague",
  VIE: "vienna",
  IST: "istanbul",
  SAW: "istanbul",
  LIS: "lisbon",
  OPO: "lisbon",
  MAD: "madrid",
  BER: "berlin",
  MUC: "munich",
  ZRH: "zurich",
  GVA: "zurich",
  DPS: "bali",
  BKK: "bangkok",
  HND: "tokyo",
  NRT: "tokyo",
  LCA: "cyprus",
  PFO: "cyprus",
  MLA: "malta",
};

/**
 * JS `\\b` only treats ASCII alphanumerics as "word chars", so it never forms
 * boundaries around Hebrew/Greek/Cyrillic/etc. Prefer separate tokens with or
 * without `\\b` for Latin vs plain substring checks for RTL/non-Latin scripts.
 */
const TEXT_RULES = [
  { re: /\bathens\b|אתונה|αθηνα/i, slug: "athens" },
  { re: /\bthessaloniki\b|סלוניקי|תסלוניקי|θεσσαλονίκη/i, slug: "thessaloniki" },
  {
    re: /\bgreece\b|ελλάδα|יוון|רודוס|כרתים|הרקליון|סנטוריני|מיקונος/i,
    slug: "greece",
  },
  {
    re: /\bmontenegro\b|מונטנגרו|\bpodgorica\b|\bbudva\b|\bkotor\b|\btivat\b/i,
    slug: "montenegro",
  },
  {
    re: /\bcroatia\b|קרואטיה|\bdubrovnik\b|דוברובניק|\bsplit\b|\bzagreb\b/i,
    slug: "croatia",
  },
  { re: /\brome\b|\broma\b|רומא|רום/i, slug: "rome" },
  { re: /\bparis\b|פריז/i, slug: "paris" },
  { re: /\blondon\b|לונדון/i, slug: "london" },
  { re: /\bdubai\b|דובאי/i, slug: "dubai" },
  { re: /\bbarcelona\b|ברצלונה/i, slug: "barcelona" },
  { re: /\bamsterdam\b|אמסטרדם/i, slug: "amsterdam" },
  { re: /\bnew york\b|\bmanhattan\b|ניו יורק/i, slug: "newyork" },
  { re: /\btel aviv\b|תל אביב/i, slug: "telaviv" },
  { re: /\bbudapest\b|בודפשט/i, slug: "budapest" },
  { re: /\bprague\b|פראג/i, slug: "prague" },
  { re: /\bvienna\b|וינה/i, slug: "vienna" },
  { re: /\bistanbul\b|איסטנבול/i, slug: "istanbul" },
  { re: /\blisbon\b|ליסבון/i, slug: "lisbon" },
  { re: /\bmadrid\b|מדריד/i, slug: "madrid" },
  { re: /\bberlin\b|ברלין/i, slug: "berlin" },
  { re: /\bmunich\b|מינכן|münchen/i, slug: "munich" },
  { re: /\bzurich\b|ציריך|zürich/i, slug: "zurich" },
  { re: /\bbali\b|באלי/i, slug: "bali" },
  { re: /\bbangkok\b|בנגקוק/i, slug: "bangkok" },
  { re: /\btokyo\b|טוקיו/i, slug: "tokyo" },
  { re: /\bcyprus\b|קפריסין|\blarnaca\b|\bpaphos\b/i, slug: "cyprus" },
  { re: /\bmalta\b|מלטה|\bvalletta\b/i, slug: "malta" },
];

function normText(s) {
  return String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{M}/gu, "");
}

const _resolveCache = new Map();

function normalizeIata(raw) {
  const u = String(raw || "").trim().toUpperCase();
  if (!u) return "";
  const m = u.match(/^([A-Z]{3})/);
  return m ? m[1] : u;
}

/**
 * @param {{ airportCodes?: string[], semanticBlob?: string }} signals
 */
export function resolveOrganizedTourHeroVisual(signals) {
  const rawCodes = (signals.airportCodes || []).filter(Boolean).map(normalizeIata).filter(Boolean);
  const blob = normText(`${signals.semanticBlob || ""} ${rawCodes.join(" ")}`);
  const cacheKey = `${rawCodes.join("|")}::${blob.slice(0, 120)}`;
  if (_resolveCache.has(cacheKey)) return _resolveCache.get(cacheKey);

  let tier = "";
  let slugUsed = null;
  let url = "";

  for (const code of rawCodes) {
    const slug =
      IATA_TO_SLUG[code] ||
      IATA_TO_SLUG[code.replace(/[^A-Z0-9]/g, "")] ||
      (code.includes("_") ? IATA_TO_SLUG[code.split("_")[0]] : "");
    if (slug) {
      const u = urlForSlug(slug);
      if (u) {
        url = u;
        tier = `destination.iata.${code}`;
        slugUsed = slug;
        break;
      }
    }
  }

  if (!url) {
    for (const rule of TEXT_RULES) {
      if (rule.re.test(blob)) {
        slugUsed = rule.slug;
        const u = urlForSlug(rule.slug);
        if (u) {
          url = u;
          tier = `destination.text.${rule.slug}`;
          break;
        }
      }
    }
  }

  if (!url) {
    url = ORGANIZED_TOUR_CURATED_GENERIC_TRAVEL_URL;
    tier = "curated.travel.generic";
    slugUsed = null;
  }

  const payload = {
    url,
    slug: slugUsed,
    tier,
    isGenericTravelFallback: tier === "curated.travel.generic",
  };
  _resolveCache.set(cacheKey, payload);
  return payload;
}
